<template>
  <div class="grid gap-5">
    <div class="flex max-w-[445px] items-center gap-2">
      <div class="relative w-full">
        <span class="text-gray-400 absolute inset-y-0 left-3 flex items-center">
          <svg
            class="size-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
        </span>
        <input
          v-model="searchQuery"
          type="text"
          placeholder="Поиск по справочнику"
          class="h-[38px] w-full rounded-lg border border-[#E9E9E9] pl-9 pr-3 text-[14px] text-[#949494] outline-none transition-colors focus:border-[#D9D9D9]"
          @keydown.enter="handleSubmit"
        />
      </div>
      <button
        type="button"
        class="h-[38px] rounded-lg bg-specialprojectsection px-5 text-[12px] font-bold uppercase tracking-wider text-white-100 transition-opacity hover:opacity-90"
        @click="handleSubmit"
      >
        Найти
      </button>
    </div>

    <div class="flex flex-wrap gap-1.5">
      <!-- <button
        type="button"
        class="flex h-[38px] w-[41px] items-center justify-center rounded-lg border border-[#D9D9D9] text-[14px] font-medium transition-all"
        :class="[
          !selectedLetter || selectedLetter === 'all'
            ? 'border-transparent bg-specialprojectsection text-white-100'
            : 'text-gray-700 hover:border-gray-400 border-new-gray-lighter',
        ]"
        @click="selectLetter('all')"
      >
        Все
      </button> -->

      <button
        v-for="letter in alphabet"
        :key="letter"
        type="button"
        class="flex h-[38px] w-[41px] items-center justify-center rounded-lg border border-[#D9D9D9] text-[14px] font-semibold uppercase transition-all"
        :class="[
          selectedLetter === letter
            ? 'border-transparent bg-specialprojectsection text-white-100'
            : 'text-gray-600 hover:border-gray-400 border-new-gray-lighter',
        ]"
        @click="selectLetter(letter)"
      >
        {{ letter }}
      </button>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  defaultLetter: {
    type: String,
    default: 'А',
  },
});

const emit = defineEmits(['change-letter', 'submit-search']);
const route = useRoute();

const alphabet = 'АБВГДЕЁЖЗИКЛМНОПРСТУФХЦЧШЩЫЭЮЯ'.split('');

const getActiveLetter = (query) =>
  query.search ? '' : query.letter || props.defaultLetter;

const searchQuery = ref(route.query.search || '');
const selectedLetter = ref(getActiveLetter(route.query));

const selectLetter = (letter) => {
  selectedLetter.value = letter;
  searchQuery.value = '';
  emit('change-letter', letter);
};

const handleSubmit = () => {
  emit('submit-search', searchQuery.value);
};

watch(
  () => route.query,
  (newQuery) => {
    searchQuery.value = newQuery.search || '';
    selectedLetter.value = getActiveLetter(newQuery);
  },
);
</script>
